import React from 'react';

/**
 * <FilterBar /> — band of filter pills + right-aligned icon buttons.
 * pills:   [{ label, value, icon?, onClick?, active?, ariaLabel? }]
 *          With onClick a pill is a real <button> (keyboard-usable, aria-pressed
 *          when `active` is given); without, it's static text.
 * actions: [{ icon, title, onClick?, ariaLabel? }]   icon-only buttons — `title` is
 *          also used as the accessible name.
 */
const FilterBar = ({ pills = [], actions = [], children }) => (
  <div className="cw-filterbar">
    {pills.map((p, i) => {
      const body = (
        <>
          {p.icon && <i className={p.icon} aria-hidden="true" />}
          {p.label ? <>{p.label} <strong>{p.value}</strong></> : <strong>{p.value}</strong>}
          {!p.icon && p.onClick && <i className="fa-solid fa-chevron-down" aria-hidden="true" />}
        </>
      );
      return p.onClick ? (
        <button
          key={i}
          type="button"
          className={`cw-filter-pill${p.active ? ' active' : ''}`}
          onClick={p.onClick}
          aria-pressed={p.active == null ? undefined : !!p.active}
          aria-label={p.ariaLabel}
        >
          {body}
        </button>
      ) : (
        <span key={i} className="cw-filter-pill static">{body}</span>
      );
    })}
    {children}
    <div style={{ flex: 1 }} />
    <div style={{ display: 'flex', gap: 4 }}>
      {actions.map((a, i) => (
        <button key={i} type="button" className="cw-icon-btn" title={a.title} aria-label={a.ariaLabel || a.title} onClick={a.onClick}>
          <i className={a.icon} aria-hidden="true" />
        </button>
      ))}
    </div>
  </div>
);

export default FilterBar;
